import SafeMailingListsOptionState from '../store/schema/SafeMailingListsOptionState';
import store from '../store/store';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { isEmailAddress } from 'owa-mail-option-common';
import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import { select } from 'satcheljs/lib/legacy';

const arrayEquals = require('array-equal');

export interface IsSafeMailingListsOptionDirtyState {
    optionState: SafeMailingListsOptionState;
    mailboxJunkEmailConfiguration: MailboxJunkEmailConfigurationOptions;
}

export default select<IsSafeMailingListsOptionDirtyState>({
    optionState: () => store,
    mailboxJunkEmailConfiguration: () => getMailboxJunkEmailConfiguration(),
})(function isSafeMailingListsOptionDirty(state?: IsSafeMailingListsOptionDirtyState) {
    const { optionState, mailboxJunkEmailConfiguration } = state!;

    if (!mailboxJunkEmailConfiguration || !optionState.safeMailingLists) {
        return false;
    }

    return !arrayEquals(
        optionState.safeMailingLists,
        mailboxJunkEmailConfiguration.TrustedRecipientsAndDomains.filter(item =>
            isEmailAddress(item)
        )
    );
});
